import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-green text-white pt-16 pb-8" data-id="element-37">
      <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-38">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-39">
          {/* Brand Col */}
          <div className="col-span-1 lg:col-span-1" data-id="element-40">
            <a href="#" className="flex items-center gap-1 mb-4" data-id="element-41">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-brand-red w-8 h-8" data-id="element-42">
                <path d="M2 22L12 2L22 22H17L12 12L7 22H2Z" fill="currentColor" data-id="element-43" />
              </svg>
              <span className="text-brand-cyan font-heading font-bold text-3xl tracking-tight whitespace-nowrap" data-id="element-44">
                AVENIR 2000
              </span>
            </a>
            <p className="text-white/70 text-sm mb-6 leading-relaxed" data-id="element-45">
              Votre partenaire en approvisionnement. Le choix, la qualité, au
              meilleur prix pour les professionnels et les particuliers.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-46">
            <h4 className="text-lg font-heading font-bold mb-6 text-brand-gold" data-id="element-47">
              Liens Rapides
            </h4>
            <ul className="space-y-3" data-id="element-48">
              <li data-id="element-49">
                <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm" data-id="element-50">
                  Accueil
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/a-propos" className="text-white/80 hover:text-white transition-colors text-sm" data-id="element-52">
                  À propos de Nous
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm" data-id="element-54">
                  Nos Produits
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm" data-id="element-56">
                  Offres Spéciales
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div data-id="element-57">
            <h4 className="text-lg font-heading font-bold mb-6 text-brand-gold" data-id="element-58">
              Catégories
            </h4>
            <ul className="space-y-3" data-id="element-59">
              <li data-id="element-60">
                <Link to="/alimentation" className="text-white/80 hover:text-white transition-colors text-sm" data-id="element-61">
                  Alimentation
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/boisson" className="text-white/80 hover:text-white transition-colors text-sm" data-id="element-63">
                  Boisson
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/maison" className="text-white/80 hover:text-white transition-colors text-sm" data-id="element-65">
                  Maison et Décoration
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/electronique" className="text-white/80 hover:text-white transition-colors text-sm" data-id="element-67">
                  Electronique
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-68">
            <h4 className="text-lg font-heading font-bold mb-6 text-brand-gold" data-id="element-69">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-70">
              <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-71">
                <MapPin className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-72" />
                <span data-id="element-73">
                  Les Coutures
                  <br data-id="element-74" />
                  45130 Baule, France
                </span>
              </li>
              <li className="flex items-center gap-3 text-white/80 text-sm" data-id="element-75">
                <Phone className="w-5 h-5 text-brand-gold shrink-0" data-id="element-76" />
                <a href="tel:+33644673704" className="hover:text-white transition-colors" data-id="element-77">
                  +33 6 44 67 37 04
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/80 text-sm" data-id="element-78">
                <Mail className="w-5 h-5 text-brand-gold shrink-0" data-id="element-79" />
                <a href="mailto:contact@avenir2000.com" className="hover:text-white transition-colors" data-id="element-80">
                  contact@avenir2000.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-81">
          <p className="text-white/50 text-sm" data-id="element-82">
            &copy; 2026 AVENIR 2000. Tous droits réservés.
          </p>
          <div className="flex gap-4 text-sm text-white/50" data-id="element-83">
            <a href="#" className="hover:text-white transition-colors" data-id="element-84">
              Mentions Légales
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-85">
              Politique de Confidentialité
            </a>
          </div>
        </div>
      </div>
    </footer>;
}